module.exports = __webpack_public_path__ + "static/media/lease-truck-program-5.91efce02.png";